// prizes.js (store)
import { ref } from 'vue';
import { defineStore } from 'pinia';
import { retrievePrizes } from '@/services/prizes.js';

// Prize type enumeration
const prizeTypeEnum = {
  WEEKLY: 'WEEKLY',
  DAILY: 'DAILY',
  MONTHLY: 'MONTHLY',
  GRAND: 'GRAND',
};

const usePrizesStore = defineStore('prizes', () => {
  const carouselPrizes = ref([]);
  const weeklyPrize = ref(null);
  const dailyPrize = ref(null);
  const monthlyPrize = ref(null);
  const grandPrize = ref(null);
  const availablePrizeTypes = ref([]);

  const dispatchRetrievePrizes = async (userLanguage = 'EN') => {
    try {
      const { data } = await retrievePrizes(userLanguage);

      // Store carousel prizes
      carouselPrizes.value = data;

      // Extract prize types
      const types = [];

      // Process each prize and categorize
      for (let i = 0; i < data.length; i += 1) {
        const prize = data[i];
        types.push(prize.type);

        if (prize.type === prizeTypeEnum.WEEKLY) {
          weeklyPrize.value = prize;
        } else if (prize.type === prizeTypeEnum.DAILY) {
          dailyPrize.value = prize;
        } else if (prize.type === prizeTypeEnum.MONTHLY) {
          monthlyPrize.value = prize;
        } else if (prize.type === prizeTypeEnum.GRAND) {
          grandPrize.value = prize;
        }
      }

      availablePrizeTypes.value = types;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  return {
    carouselPrizes,
    weeklyPrize,
    dailyPrize,
    monthlyPrize,
    grandPrize,
    availablePrizeTypes,
    dispatchRetrievePrizes,
  };
});

export default usePrizesStore;
